<template>
    <div>
        <div v-if="!isLoading">
            <div>
                <div
                    class="claim-list-card"
                    :class="index > 0 ? 'mt-2' : ''"
                    v-for="(option, index) in repairOptionsList"
                    :key="index" >
                    <div class="row claim-list-card-body">
                        <div class="col-sm-3 text-center">
                            <i
                                v-bind:class="option.repairOptionWebDisplayIcon"
                                style="font-size: 92px;">
                            </i>
                        </div>
                        <div class="col border-right border-left">
                            <h4>{{option.repairOptionWebDisplayTitle}}</h4>
                            {{option.repairOptionWebDisplayDescription}}
                        </div>
                        <div class="col-sm-3">
                            <button @click="optionSelected(option)" class="button-small float-right">Details...</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            Loading...
        </div>
    </div>
</template>

<script>
export default {
  name: 'repairOptionsList',
  computed: {
    isLoading () {
      return this.$store.state.repairoptions.loading
    },
    repairOptionsList () {
      return this.$store.state.repairoptions.repairOptionsList
    }
  },
  data: () => {
    return {

    }
  },
  methods: {
    optionSelected (option) {
      this.$emit('selected',
        { ...option }
      )
    }
  }
}
</script>
